var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-stat"},[(_vm.textValue)?_c('h3',{staticClass:"player",class:_vm.cssclass},[_vm._v(_vm._s(_vm.textValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }